import { Component } from "react";
import { connect } from "react-redux";
import formatDateArabicDZ from "../utils/formatDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPrint } from "@fortawesome/free-solid-svg-icons";
import urls, { mainUrl } from "../urls";
import axios from "axios";
import { showSuccess, showError } from "../utils/notifications";
import { updateOrderStatus } from "../redux-state/features/orderState";
class ManagerTableRow extends Component {
  confirmOrder = (orderId) => {
    console.log("orderId-> ", orderId);
    axios
      .post(urls.fullFillOrder, {
        data: { orderId, orderStatus: "confirmed", applicationType: "order" },
      })
      .then((res) => {
        this.props.updateOrderStatus({
          orderId,
          updatedProperties: { status: "confirmed" },
        });
        showSuccess("تم تأكيد تسليم الطلب ");
      })
      .catch((err) => {
        console.log(err);
        showError("لم يتم تأكيد  تسليم الطلب ");
      });
  };
  render() {
    const { orderNumber } = this.props;
    const { full_name, email, order_date, orderId, status } = this.props.obj;
    return (
      <tr className="text-center">
        <td>{orderNumber}</td>
        <td>{full_name}</td>
        <td>{email}</td>
        <td>{formatDateArabicDZ(order_date)}</td>
        <td>
          <a
            href={`${mainUrl}/api/print/order-receipt/${orderId}`}
            target="_blank"
            className="btn btn-outline-primary"
          >
            <FontAwesomeIcon icon={faPrint} size="lg" />
            <span className="mx-3">طباعة </span>
          </a>
        </td>
        <td>
          {status === "served" ? (
            <p>تم تأكيد الأستلام </p>
          ) : status === "confirmed" ? (
            <p>تم تسليم الطلب في انتظار تأكيد المستخدم</p>
          ) : (
            <button
              className="btn  btn-outline-success "
              onClick={() => this.confirmOrder(orderId)}
            >
              <FontAwesomeIcon
                className="mx-2"
                icon={faCheck}
                title="قبول الطلب"
              />
              تأكيد التسليم
            </button>
          )}
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = { updateOrderStatus };
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ManagerTableRow);
